import { Box, Container, createTheme, CssBaseline, Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getOneInByClave, getOneInByReferencia } from "../../services/crudCustom";
import { WaitDialog } from "../modules/dialogs/WaitDialog";
import ApplicationBar from "../modules/ui/ApplicationBar";
import QRCode from 'qrcode';
import { Footer } from "../modules/ui/Footer";
import moment from "moment";
import { getAllEventosConRegistro, getByClaveProyecto } from "../../database/dbEventosConRegistro";


export const VisualizarRegistro = () => {
    // Hook que obtiene los parametros que se envian por la url
    let params = useParams();
    const { ref } = params;

    // state para cargar info
    const [isLoading, setIsLoading] = useState(false);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({ 
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
    });

    // state para los valores del evento
    const [event, setEvent] = useState({ });

    // state para los pares key-value de los encabezados de las tablas
    const [items, setItems] = useState([ ]);
    
    // state para el QR
    const [sourceQR, setSourceQR] = useState({ qrdata: "" });
    

    useEffect(() => {
        document.title = "Visualizar registro CIBNOR";

        const loadInitialData = async() => {
            // Recupera el registro individual
            let { exito, data, mensaje} = await getOneInByReferencia({ table:'RegistroGeneral', referencia:ref });
            
            // Si no existe, avisa y se sale
            if (exito === 0) {
                console.log('No existe el registro: ' + mensaje);
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "No existe el registro.",
                    text: `La referencia ${ ref } es invalida.`,
                    footer: `Dudas o aclaraciones: educon@cibnor.mx`,
                    showConfirmButton: false,
                    icon: 'error',
                });
                return;
            }
            
            // Obtenemos el registro
            let recordData = data[0];
            recordData.infoAdTmp = JSON.parse(recordData.infoAdicional);
            console.log({recordData});

            // Obtenemos el evento
            const claveProyectoTmp = recordData.registroReferencia.substring(0, 5);
            console.log({claveProyectoTmp});

            const { data: proyDataTmp } = await getByClaveProyecto(claveProyectoTmp);
            const proyData = proyDataTmp[0];
            // console.log({proyData});
            
            // var proyData = {
            //     tituloEvento: recordData.infoAdTmp.educonTitulo || recordData.infoAdTmp.eventoTitulo,
            //     urlLogo: 'https://eventos.cibnor.mx/intranet/img/logo_cib.png',
            // }
            // var proyData = eventosConRegistro.find(ev => ev.solicitudFolio === educonSolicitudId.toString())
            console.log({proyData});
            setEvent(proyData);

            setFormValues(recordData);

            // Arreglamos los encabezados a mostrar
            let items = [];
            let itemsKeys = Object.keys(recordData);
            let itemsValues = Object.values(recordData);;

            for (let index = 0; index < itemsKeys.length; index++) {

                // console.log(itemsKeys[index]);
                // Si es una fecha, formatear 'DD MMMM YYYY'
                if ( itemsKeys[index] === 'registroFecha' || itemsKeys[index] === 'fechaPago' ) {
                    
                    console.log(itemsValues[index]);
                    if (itemsValues[index] !== null) {
                        
                        itemsValues[index] = moment( itemsValues[index] ).format('DD MMMM YYYY');
                    }
                }

                // --- Los dos campos del comprobante, convertirlos a uno solo
                if ( itemsKeys[index] === 'compPagoURLLabel' ) {
                    items.push({ 
                        key : itemsValues[index], 
                        value : itemsValues[index+1]
                    });
                    continue;
                }
                if ( itemsKeys[index] === 'compPagoURL' ) {
                    continue;
                }
                // --- 

                if ( recordData.factExtranjero === 'true') {
                    // Es extranjero, omite requiereFactura
                    if ( itemsKeys[index] === 'requiereFactura' ) { continue; }
                } 
                else {
                    // Es nacional, omite factExtranjero
                    if ( itemsKeys[index] === 'factExtranjero' ) { continue; }
                }

                //* Extraemos lo que necesitemos de infoAdicional
                if (itemsKeys[index] === 'infoAdicional') {
                    const infoAdicional = JSON.parse(itemsValues[index]);
                    console.log({infoAdicional});

                    if (infoAdicional.compPagoFecha) {
                        
                        if (infoAdicional.compPagoFecha.length > 0) {
                            items.push({ key : 'FECHA DE COMPROBACIÓN DEL PAGO', value : infoAdicional.compPagoFecha });
                            items.push({ key : 'CONSULTAR COMPROBANTE', value : infoAdicional.compPagoURL });
                        }
                    }

                    if (infoAdicional.requiereFactura) {
                        items.push({ key : 'REQUIERE FACTURA', value : 'SI' });
                        
                        if (infoAdicional.factExtranjero) {
                            items.push({ key : 'A NOMBRE DE', value : infoAdicional.factExtNombre });
                            items.push({ key : 'DATOS A AGREGAR', value : infoAdicional.factExtConcepto });
                        } else {
                            items.push({ key : 'A NOMBRE DE', value : infoAdicional.factNombre });
                            items.push({ key : 'RFC', value : infoAdicional.factRFC });
                            items.push({ key : 'CP', value : infoAdicional.factCP });
                            items.push({ key : 'REGIMEN FISCAL', value : infoAdicional.factRegimenFiscal });
                            items.push({ key : 'USO CFDI', value : infoAdicional.factUsoCFDI });
                        }

                    } else {
                        items.push({ key : 'REQUIERE FACTURA', value : 'No' });
                    }
                    continue;
                }

                if ( itemsKeys[index] === 'tipoRegistroDocURL' ) {
                    console.log(itemsKeys[index]);
                    console.log(itemsValues[index]);
                    items.push({ 
                        key : 'Documento probatorio', 
                        value : itemsValues[index] 
                    });
                    continue;
                }

                // Agregar a items el par valor a mostrar
                items.push({ 
                    key : itemsKeys[index].replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase().replace('PART ', ''), 
                    value : itemsValues[index] 
                });
            }

            
            console.log({items});
            // Seteamos los items que se mostraran en pantalla
            setItems(items);

            // Generamos el QR para mostrar
            const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${recordData.registroReferencia}`;

            QRCode.toDataURL( qrString )
            .then( (data) => {
                setSourceQR( { qrdata:data } ); 
            })

        }
        setIsLoading(true);
        loadInitialData();
        setIsLoading(false);
        
    }, [ ref ])

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="md">
            <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                { event && (
                    <ApplicationBar 
                        title={ event.tituloEvento } 
                        subtitle={`Datos de registro de ${formValues.partNombres} ${formValues.partApellidoPaterno} ${formValues.partApellidoMaterno} `} 
                        logo={ event.urlLogo } 
                        logoVariant='square'
                    />
                )}
                    {/* QR */}
                    { (formValues.compPagoFecha !== '') ? 
                        <Grid item xs={12} sx={{ textAlign:'center' }} >
                            <img src={ sourceQR.qrdata } alt="QR" width={ 200 } />
                        </Grid>
                    : ''}
                    
                    {/* Contenedor general */}
                    <Grid
                        container
                        maxWidth={window.innerWidth}
                        spacing={2}
                        sx={{ pt: 2, pb: 3 }}
                    >

                        {items.map(({ key, value }) => (
                            // Excluye los que tienen como valor 'null' o '', y los siguientes campos...                            
                            ((value !== null) && (value !== '') &&
                                !(  [
                                        "ID", 
                                        "CLAVE PROY REC",
                                        "INFO AD TMP",
                                        "REGISTRO CLAVE PROYECTO",
                                    ].includes(key) )
                            ) &&
                            ( 
                                // Es un URL? usa su key como label del link
                                (value.length > 0 && value.startsWith("http")) ?
                                (<Grid item xs={12} key={ key }>
                                    <Typography>
                                        <a href={ value } target="_blank" rel="noreferrer" >{ key }</a>
                                    </Typography>
                                </Grid>) 
                                :
                                (<Grid item xs={12} key={ key }>
                                    <TextField
                                        // Si value es diferente a true o false...
                                        value={( 
                                            (value !== 'true' && value !== 'false') ? value 
                                            : ( 
                                                ((value === 'false') && 'No' ) ||
                                                ((value === 'true') && 'Si' )
                                                ) 
                                        )}
                                        fullWidth
                                        variant="standard"
                                        size="small"
                                        label={ key }
                                        InputProps={{ readOnly: true, }}
                                    />
                                </Grid>)
                            )
                        ))}

                    </Grid>
                    {/* Footer */}
                    <Footer />
                </Box>
            </Container>
            {/* Dialogo de cargando info */}
            <WaitDialog show={isLoading} />
        </ThemeProvider>
    );
};
